import { Observable } from 'rxjs'
import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core'

import {
  IEntityListConfig,
  IAddEvent
} from '../../../'

import { EntityListRegistryService } from '../../../services'

import { IFormOption } from '../../../forms/services'
import { BaseModel } from '../../../data/models'
import { Utils, AppInjector } from '../../../helpers'

@Component({
  selector: 'mp-entity-manager',
  templateUrl: './entity-manager.html'
})
export class EntityManagerComponent implements OnChanges {

  @Input() public modelType: string

  @Output() public editClicked: EventEmitter<BaseModel> = new EventEmitter<BaseModel>()
  @Output() public addClicked: EventEmitter<IAddEvent> = new EventEmitter<IAddEvent>()

  public entities: Observable<BaseModel[]>
  public config: IEntityListConfig
  public defaultOption: IFormOption = { value: '', label: ''}
  public selectedOption: IFormOption = this.defaultOption
  public options: Observable<IFormOption[]>

  constructor(
    private _appInjector: AppInjector,
    private _entityListRegistry: EntityListRegistryService,
    private _utils: Utils
  ) {}

  public ngOnChanges(changes) {
    if (changes.modelType) {
      const service = this._appInjector.getServiceForModel(this.modelType)
      this.config = this._entityListRegistry.getConfig(this.modelType)
      this.options = this.config.optionsCallback()
      this.entities = service.findAllModelsWithRelationships()
    }
  }

  public onEditClicked(entity: BaseModel) {
    this.editClicked.emit(entity)
  }

  public onAddClicked() {
    const addInfo = {
      modelType: this.modelType,
      requiredModel: this.selectedOption.value
    }
    this.addClicked.emit(addInfo)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/entity-manager/entity-manager.component.ts